module.exports = __webpack_public_path__ + "img/ludovic_square.4915b091.jpg";